import { FeatureFlag } from './FeatureFlag';

/**
 * Human-readable description of what each feature flag does, shown next to the
 * toggle in the SHIFT+? dev dialog (ENG-2397). Typed as a total record so a new
 * flag can't be added to the enum without also describing it.
 */
export const featureFlagDescriptions: Record<FeatureFlag, string> = {
  [FeatureFlag.CoinList]:
    'Legacy coin/cash-list cash handling with coin-denomination entry (Drescher only).',
  [FeatureFlag.DevTools]:
    'Reveals internal developer/testing tools (error triggers, testing modal, test IBANs) hidden from normal users.',
  [FeatureFlag.HideCashManagementDeposit]:
    'When on, hides the Deposit option in the cash change form so staff can only withdraw.',
  [FeatureFlag.HideCashManagementTransfer]:
    'When on, hides the transfer-between-cash-lists action in cash management.',
  [FeatureFlag.HidePliantReferenceInLinkSelector]:
    'When on, hides the Pliant reference cash list from the receipt cash-link selector.',
  [FeatureFlag.HidePliantReferenceInOverview]:
    'When on, hides the Pliant reference cash list from the cash overview and account lists.',
  [FeatureFlag.AccountingPaymentsNew]:
    'Enables the new bank-account-based accounting & payments module and its navigation.',
  [FeatureFlag.dev_ServiceProviderApp]:
    'Shows the service-provider section: navigation, receipt batches, and payments.',
  [FeatureFlag.dev_CaritasManualRoles]:
    'Enables manual role assignment for employees in the employee form.',
  [FeatureFlag.AccountingPayments]:
    'Enables the legacy (cash-management) accounting & payments module; slated for removal.',
  [FeatureFlag.dev_ResidentTypeSelector]:
    'Shows the resident-type selector in the add-resident form.',
  [FeatureFlag.dev_InitialBalanceForResident]:
    'Shows the initial-balance field when creating a resident.',
  [FeatureFlag.dev_NationalityAndCountryOfResidenceSelectors]:
    'Shows the nationality and country-of-residence selectors in the add-resident form.',
  [FeatureFlag.dev_OfflineSepaMandate]:
    'Shows the create-offline-SEPA-mandate action for residents without a family member (MangoPay only).',
  [FeatureFlag.dev_OfflineSepaManualPayin]:
    'Allows a manual pay-in for residents that have an offline SEPA mandate.',
  [FeatureFlag.dev_UnassignPliantTransaction]:
    'Shows the action to unassign a Pliant card transaction from a nursing home.',
  [FeatureFlag.ExpenseManagement]:
    'Enables the expense & budget management module (expense tracking, budgets, exports).',
  [FeatureFlag.ReceiptManagement]:
    'Enables receipt upload and attachment features across transactions and Pliant.',
  [FeatureFlag.ReceiptImageAnalysis]:
    'Automatically analyses captured receipt images (OCR/AI) to pre-fill expense data.',
  [FeatureFlag.ReceiptDocumentScanner]:
    'Uses the native document scanner (instead of the plain camera) to capture receipts on mobile.',
  [FeatureFlag.MainCashboxAdjustmentFlag]:
    'Shows the Hauptkasse (main cashbox) prompt when creating an Adjustment cash transaction.',
  [FeatureFlag.dev_LegalEntityScope]:
    'Shows the Legal entity tab in the scope selector (tenant-level only).',
  [FeatureFlag.dev_TenantScope]:
    'Shows the Tenant (all homes) tab in the scope selector (tenant-level only).',
  [FeatureFlag.MismatchRiskTab]:
    'Shows the Mismatch risk tab in the cash transaction group list.',
};
